import { render, staticRenderFns } from "./STabItem.vue?vue&type=template&id=0fcb1d44&scoped=true&"
import script from "./STabItem.vue?vue&type=script&lang=js&"
export * from "./STabItem.vue?vue&type=script&lang=js&"
import style0 from "./STabItem.vue?vue&type=style&index=0&id=0fcb1d44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb1d44",
  null
  
)

export default component.exports